type Props = {
    moderationStyle: string | undefined
    socialMediaServiceName: string
    iconName: string
    isPublic: boolean
    rounded?: boolean
    isSelected: boolean
}
export default function ContentSidebar(props: Props) {
    const { moderationStyle, socialMediaServiceName, iconName, isPublic, rounded } = props

    return (
        <div
            // Hidden on narrow cards: 48px of rail is a sixth of a 344px reply
            // card. The platform icon moves inline into the metadata row there.
            className={`bg-gray-500 text-white bg-${moderationStyle} ${
                rounded ? 'rounded-tl-lg rounded-bl-lg' : ''
            } hidden flex-col items-center justify-between px-1.5 text-base @sm:flex @lg:px-3 @lg:text-2xl `}
        >
            <i
                data-tooltip-id="tooltip-id"
                data-tooltip-content={`This content comes from from ${socialMediaServiceName}`}
                className={`fab mt-4 ${iconName} w-5 text-white @lg:w-6`}
            ></i>

            {isPublic ? (
                <>
                    <p
                        data-tooltip-id="tooltip-id"
                        data-tooltip-content={`This content has come from a mention`}
                        className="mb-4 w-5 @lg:w-6"
                    >
                        @
                    </p>
                </>
            ) : (
                <>
                    <i
                        data-tooltip-id="tooltip-id"
                        data-tooltip-content={`This content has come from a direct message`}
                        className="fas fa-envelope mb-4 w-5 @lg:w-6"
                    ></i>
                </>
            )}
        </div>
    )
}
